const state = function () {
  return {
    navDrawer: true,
    currentUser: {
      
    },
    detailsModal: {
      open: false,
      mode: ''
    },
    // global Modals
    certificatesModal: false,
    studentCompletionModal: false,
    recruiterReferralModal: false,
    accountingReportModal: false,
    affiliateScheduleModal: false,
    unscheduledClassesModal: false,
    navigationItems: [
    {
      selected: false,
      title: 'Users',
      route: '/users',
      module: 'users',
      icon: 'fa fa-user',
      $p: [['ADMIN','MANAGER','RECRUITER','AFFILIATE'],'or'],
      // children: [
      //   {
      //     selected: false,
      //     title: 'All Users',
      //     route: '/users/all',
      //     module: 'students',
      //     icon: 'fa fa-users'
      //   }
      // ]
    }, 
    {
      selected: false,
      title: 'Students',
      route: '/students',
      module: 'students',
      $p: [['ADMIN','MANAGER','RECRUITER','INSTRUCTOR','AFFILIATE'],'or'],
      icon: 'fa fa-users'
    },
    {
      selected: false,
      title: 'Courses',
      route: '/courses',
      module: 'courses',
      icon: 'fa fa-book',
      $p: [['ADMIN','MANAGER'],'or'],
    }, 
    {
      selected: false,
      title: 'Classes',
      route: '/classes',
      module: 'classes',
      icon: 'fa fa-slideshare',
      $p: [['ADMIN','MANAGER','RECRUITER','INSTRUCTOR','AFFILIATE'],'or'],
      children: [
        {
          selected: false,
          title: 'List',
          route: '/classes/list',
          module: 'classes',
          $p: [['ADMIN','MANAGER','RECRUITER','INSTRUCTOR','AFFILIATE'],'or'],
          icon: 'fa fa-list-ul'
        },
        {
          selected: false,
          title: 'Calendar',
          route: '/classes/calendar',
          module: 'classes',
          $p: [['ADMIN','MANAGER','RECRUITER','INSTRUCTOR','AFFILIATE'],'or'],
          icon: 'date range'
        }        
      ]
    },
    {
      selected: false,
      title: 'Approvals',
      route: '/approvals',
      module: 'approvals',
      icon: 'fa fa-thumbs-o-up',
      $p: [['ADMIN','MANAGER'],'or'],
      children: [
        {
          selected: false,
          title: 'Classes',
          route: '/approvals/classes',
          module: 'classApprovals',
          $p: [['ADMIN','MANAGER'],'or'],
          icon: 'fa fa-slideshare'
        },
        {
          selected: false,
          title: 'Instructors',
          route: '/approvals/instructors',
          $p: [['ADMIN','MANAGER'],'or'],
          module: 'instructorApprovals',
          icon: 'fa fa-graduation-cap'
        }
      ]
    },
    {
      selected: false,
      title: 'Orders',
      route: '/orders',
      module: 'orders',
      $p: [['ADMIN','MANAGER','INSTRUCTOR','AFFILIATE'],'or'],
      icon: 'fa fa-shopping-cart'
    },
    {
      selected: false,
      title: 'Reports',
      module: 'reports',
      icon: 'fa fa-area-chart',
      expand: false,
      $p: [['ADMIN','MANAGER','RECRUITER'],'or'],
      children: [
        {
          selected: false,
          title: 'Accounting Report',
          modal: 'accountingReport',
          module: 'reports',
          icon: 'fa fa-money',
          $p: [['ADMIN'],'or']
        },
        {
          selected: false,
          title: 'Affiliate Schedule',
          modal: 'affiliateSchedule',
          module: 'reports',
          icon: 'fa fa-calendar-check-o',
          $p: [['ADMIN','MANAGER'],'or']
        },
        {
          selected: false,
          title: 'Recruiter Referral',
          modal: 'recruiterReferral',
          module: 'reports',
          icon: 'fa fa-money',
          $p: [['ADMIN','MANAGER','RECRUITER'],'or']
        },
        {
          selected: false,
          title: 'Student Completion',
          modal: 'studentCompletion',
          module: 'reports',
          icon: 'fa fa-graduation-cap',
          $p: [['ADMIN','MANAGER'],'or']
        },
        {
          selected: false,
          title: 'Unscheduled Classes',
          modal: 'unscheduledClasses',
          module: 'reports',
          icon: 'fa fa-clock-o',
          $p: [['ADMIN','MANAGER'], 'or']
        }
      ]
    },
    {
      selected: false,
      title: 'Certificates',
      route: '/certificates',
      module: 'certificates',
      icon: 'fa fa-certificate',
      $p: [['ADMIN','MANAGER'],'or']
    },
    {
      selected: false,
      title: 'Resources',
      route: '/resources/documents',
      module: 'resources',
      icon: 'fa fa-folder-open',
      $p: [['ADMIN','MANAGER','RECRUITER','INSTRUCTOR','AFFILIATE'],'or']
    },
    {
      selected: false,
      title: 'Event Log',
      route: '/eventlog',
      module: 'eventlog',
      icon: 'fa fa-list',
      $p: [['ADMIN'],'or'],
    },
    {
      selected: false,
      title: 'Roster Jobs',
      route: '/jobs',
      module: 'jobs',
      icon: 'fa fa-clipboard',
      $p: [['ADMIN', 'AFFILIATE'],'or'],
    },
    ],
    genders: [
      { label: 'M - Male', value: 0 },
      { label: 'F - Female', value: 1 },
      { label: 'U - Unidentified', value: 2 },
      { label: 'I - Intersex', value: 3 }
    ],
    entities: [],
    states: [],
    activeIndicators: [
      { label: '', value: null },
      { label: 'Active', value: 1 },
      { label: 'Inactive', value: 0 }
    ],
    userTypes: [],
    suffixes: [],
    documentTypes: [],
    fileTypes: [],
    shippingTypes: [],
    orderTypes: [],
    orderStatuses: [],
    paymentMethods: [],
    classes: {
      affiliates: {}
    },
    formats: {
      date: 'M/D/YY',
      datetime: 'MMM Do, YYYY h:mmA',
      time: 'h:mmA'
    },
    time: {
      hours: [],
      minutes: [],
      period: [
        { label: "AM", value: "AM" },
        { label: "PM", value: "PM" }
      ]
    }
  }
}

export default {
  ...state()
}

export const initialState = state()
